import { initialiseCarousel } from "./_helpers";
import { mediaBreakpoints } from "../utils";
import { getElement, getElements } from "./../utils/functional";
import "swiper/swiper.scss";


export default function init({ el, context }) {
  
  const accordionBtns = document.querySelectorAll(".accordion-btn"),
        accordionPanels = document.querySelectorAll(".accordion-panel");
  const moduleClassName = el.dataset.moduleClassName,
        swiperContainer = el.getElementsByClassName(`${moduleClassName}_Carousel`)[0],
        swiperNext = el.getElementsByClassName(`${moduleClassName}_Next`)[0],
        swiperPrevious = el.getElementsByClassName(`${moduleClassName}_Previous`)[0],
        slideClass = `${moduleClassName}_Slide`;
  var navigation = false;

  accordionBtns.forEach((btn, index) => {
    document.addEventListener("click", (btnClick) => {
      if (btnClick.target === btn) {
        let panel = accordionPanels[index];
        btn.classList.toggle("open-accordion");
        panel.classList.toggle("open-accordion");
      }
    });
  });

  navigation = {
    nextEl: swiperNext,
    prevEl: swiperPrevious,
    disabledClass: "attributes__swiper--navigation__disabled",
  };

  window.addEventListener("resize", makeCarousel);

  makeCarousel();

 function makeCarousel() {
   var swiperInstance = initialiseCarousel(swiperContainer, {
     spaceBetween: 100,
     centeredSlides: false,
     slideClass: slideClass,
     slidesPerView: 1.2,
     preloadImages: false,
     watchSlidesProgress: true,
     setWrapperSize: true,
     watchOverflow: true,
     lazy: true,
     loop: false,
     breakpointsInverse: true,
     breakpoints: {
       468: {
         slidesPerView: 2.7,
       },
       1200: {
         slidesPerView: 5,
       },
     },
     navigation: {
       nextEl: swiperNext,
       prevEl: swiperPrevious,
       disabledClass:
         "attributes__swiper--navigation__disabled",
     },
   });
   setTimeout(function() {
     swiperInstance.update();
   }, 2000);
 }
}
